import styled from 'styled-components';

export const ModalOfferContainer = styled.section`
    .partner-row {
        height: auto;
        border-right: none;
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        .partner-row {
            border-right: 1px solid ${props => props.theme.partnerBlockHorizontalBorderColor};
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/offer/ModalOfferComponentStyle.js